import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { api, get } from "@config"

import Select from 'react-select'
import { setLoading } from "@inspinia-react/actions";
import { setCNAE } from "./actions";
import { mapTest } from "../../pages/products/map.test";

function CNAE(props) {

  const [code, setCode] = useState('')
  const [description, setCnaeDescription] = useState('')
  const [list, setCnaeList] = useState([])
  const [input, setInput] = useState('')

  function reducerResult(result) {
    const r = result.map(item => ({ label: item.code, value: item.id, desc: item.description }))
    setCnaeList(r)
  }

  function searchCnae(e = code) {
    e = e.replace(/\D/g, '')
    setInput(e)
    if (e.length < 5) {
      return
    }

    props.setLoading(true)
    const url = `${api.defaultData.cnae}?code=${e}`;
    const payload = result => {
      props.setLoading(false)

      if (result.length === 0) {
        setCnaeDescription("Código não encontrado")
        return
      } else if (result.length === 1) {
        const [cnae] = result
        reducerResult(result)
        setCode(cnae.code)
        setCnaeDescription(cnae.description)
        props.setCNAE(cnae.id)
      } else {
        reducerResult(result)
      }
    }
    get(url, payload)
  }

  React.useEffect(() => {
    if (props.default) {
      setCode(props.default.code)
      setCnaeDescription(props.default.description)
    }
  }, []);

  return <div id="company-data" className='py-1 col-lg-6 col-sm-12'>
    <div data-company-data className="py-2">
      <p>Código de Atividade Principal (CNAE)</p>
      <Select
        id={mapTest.createBranch.info.fields.inputBranchCnae}
        isLoading={props.loading}
        placeholder={props.default ? props.default.code : "Busque aqui"}
        inputValue={input}

        onChange={e => {
          props.setCNAE(e.value)
          setCnaeDescription(e.desc)
        }}
        onInputChange={searchCnae}
        noOptionsMessage={s => "Sem resultados"}
        options={list} />
      <p className="my-1" >
        <a href="#" onClick={() => {
          const cnpj = props.doc ? `?cnpj=${props.doc}` : "";
          window.open(
            `https://solucoes.receita.fazenda.gov.br/Servicos/cnpjreva/`,
            "_blank"
          );
        }}>Não sei meu CNAE</a></p>{
        description.substr(0, 100)
      }
    </div>
  </div>
}

const mapStateToProps = state => ({
  loading: state.loading,
  doc: state.personDoc,
  cnae: state.cnae
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ setLoading, setCNAE }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CNAE);



// WEBPACK FOOTER //
// ./src/components/parts/company-data/cnae.jsx